import styled from "styled-components";

export const SendCodeAgain = styled.p`
  color: ${({ theme }) => theme.colors.primary.vividCerulean};
  ${({ theme }) => theme.font.body.x};
  font-weight: ${({ theme }) => theme.font.weight.medium};
  cursor: pointer;
`;
